import { render, staticRenderFns } from "./InputFocus.vue?vue&type=template&id=66856798&"
import script from "./InputFocus.vue?vue&type=script&lang=js&"
export * from "./InputFocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports